var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,index){return (_vm.errors.length > 0)?_c('small',{key:index,staticClass:"validation form-text text-danger"},[_vm._v(_vm._s(error))]):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }